export default "__VITE_ASSET__044de0b3__"